<template>
  <div>
    <div v-if="currentUser && currentUser.uid != 0" class="the-navbar__user-meta flex items-center">
      <div class="text-right leading-tight hidden sm:block">
        <p class="font-semibold">{{ displayName }}</p>
        <small>{{ currentUser.email }}</small>
      </div>
      <vs-dropdown :key="dropdownKey" vs-custom-content vs-trigger-click class="cursor-pointer">
        <div class="con-img ml-3">
          <img
            v-if="currentUser.photoURL"
            key="onlineImg"
            :src="currentUser.photoURL"
            alt="user-img"
            width="40"
            height="40"
            class="rounded-full shadow-md cursor-pointer block"
          />
        </div>

        <vs-dropdown-menu class="vx-navbar-dropdown">
          <ul style="min-width: 12rem">
            <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
              @click="goToSettings"
            >
              <feather-icon icon="SettingsIcon" svg-classes="w-4 h-4" />
              <span class="ml-2">Settings</span>
            </li>
            <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
              @click="logout"
            >
              <feather-icon icon="LogOutIcon" svg-classes="w-4 h-4" />
              <span class="ml-2">Logout</span>
            </li>
          </ul>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
    <div v-else>
      <vs-button class="!mr-4" color="primary" type="border" @click="goToLogin">Login</vs-button>
      <vs-button color="primary" type="border" @click="goToRegister">Register</vs-button>
    </div>
  </div>
</template>

<script>
import { BUTTON_CLICKED_EVENT, TEXT_CLICKED_EVENT } from "@/assets/constants/analytics";

export default {
  data() {
    return { dropdownKey: 0 };
  },
  computed: {
    displayName() {
      if (
        this.$store.getters["userInfo/getFirstName"] === undefined ||
        this.$store.getters["userInfo/getLastName"] === undefined
      ) {
        return "";
      }

      return (
        this.$store.getters["userInfo/getFirstName"] +
        " " +
        this.$store.getters["userInfo/getLastName"]
      );
    },
    currentUser() {
      return this.$store.getters["auth/getUser"];
    },
  },
  methods: {
    logout() {
      this.$analytics.logEvent(TEXT_CLICKED_EVENT, {
        content: "Logout",
      });
      this.$store.dispatch("auth/signOut").then(() => {
        this.$router.go();
      });
    },
    goToSettings() {
      this.$analytics.logEvent(TEXT_CLICKED_EVENT, {
        content: "Settings",
      });
      this.$router.push({ name: "settings_overview" });
      // Allow for the close of the drop down element.
      // It's needed because we use custom list elements
      // and not vs-dropdown-item.
      this.dropdownKey++;
    },
    goToRegister() {
      this.$analytics.logEvent(BUTTON_CLICKED_EVENT, {
        content: "Register",
      });
      this.$router.push({ name: "page-register" });
    },
    goToLogin() {
      this.$analytics.logEvent(BUTTON_CLICKED_EVENT, {
        content: "Login",
      });
      this.$router.push({ name: "page-login" });
    },
  },
};
</script>
